// extracted by mini-css-extract-plugin
export default {"settings-popover":"EnitityPickerDefaultSettings_settings-popover__5q6kx","settings-paper":"EnitityPickerDefaultSettings_settings-paper__7Krrq"};